import React, { FunctionComponent } from 'react';

import { StructuredFileMetadata } from '@api/uploaders';
import { FontIcon, FontIcons } from '@components/library/icon';
import { FilestackPreviewImage } from '@components/common/filestack_uploader/FilestackPreviewImage';

import './styles/guest-upload-file-list.scss';

interface GuestUploadFileListProps {
  allFiles: StructuredFileMetadata[];
  brandfolderKey: string;
  uploadLinkKey: string;
}

export const GuestUploadFileList: FunctionComponent<GuestUploadFileListProps> = ({
  allFiles,
  brandfolderKey,
  uploadLinkKey
}) => (
  <ul className="guest-upload__file-list bf-scroll-element">
    {allFiles.map((file, index: number) => (
      <li key={`guest-upload-file${index}`} className="guest-upload__file-list--item">
        <div className="guest-upload__file-list--item-container-left">
          <div className="guest-upload__file-list--item-thumbnail">
            <FilestackPreviewImage
              alt="thumbnail of guest upload image"
              className="no-select"
              resourceKey={brandfolderKey}
              resourceType="brandfolder"
              src={file.url}
              uploadLinkKey={uploadLinkKey}
            />
          </div>
          <p className="guest-upload__file-list--item-filename">{file.filename}</p>
        </div>
        <p className="guest-upload__file-list--item-confirmation">
          <FontIcon aria-hidden icon={FontIcons.CheckMark} />{bfTranslate('Uploaded')}
        </p>
      </li>
    ))}
  </ul>
);
